<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card box-shadow-title">
        <div class="card-header p-b-40">
          <div class="media">
            <h4>{{ "admin.campaigns.calendar.title" | translate }}</h4>
            <div class="media-body text-end">
              <form class="d-inline-flex" [formGroup]="formFilter">
                <app-date-range-picker
                  [form]="formFilter | asFormGroup"
                  inputFormControlName="date"
                ></app-date-range-picker>
                <app-search-field
                  [form]="formFilter | asFormGroup"
                  [filterOptions]="filter"
                  [placeholder]="
                    'placeholder.searchByCampaignTitle' | translate
                  "
                  inputFormControlName="title"
                  (emitSelectedOptions)="saveOption($event)"
                ></app-search-field>
                <button
                  class="btn btn-primary m-l-10"
                  type="button"
                  (click)="removeFilter()"
                >
                  <i class="fa fa-repeat me-2"></i>
                  {{ "buttons.removeFilter" | translate }}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div class="card-body" *ngIf="!(loading$ | async)">
          <div class="row">
            <div class="d-flex justify-content-between col-12">
              <div class="btn-group">
                <div
                  class="btn btn-primary"
                  mwlCalendarPreviousView
                  [view]="view"
                  [(viewDate)]="viewDate"
                  (viewDateChange)="closeOpenMonthViewDay()"
                >
                  {{ "admin.campaigns.calendar.previous" | translate }}
                </div>
                <div
                  class="btn btn-outline-primary"
                  mwlCalendarToday
                  [(viewDate)]="viewDate"
                >
                  {{ "admin.campaigns.calendar.today" | translate }}
                </div>
                <div
                  class="btn btn-primary"
                  mwlCalendarNextView
                  [view]="view"
                  [(viewDate)]="viewDate"
                  (viewDateChange)="closeOpenMonthViewDay()"
                >
                  {{ "admin.campaigns.calendar.next" | translate }}
                </div>
              </div>
              <h3>
                {{ viewDate | calendarDate : view + "ViewTitle" : "en" }}
              </h3>
              <div class="btn-group">
                <div
                  class="btn btn-primary"
                  (click)="setView(CalendarView.Month)"
                  [class.active]="view === CalendarView.Month"
                >
                  {{ "admin.campaigns.calendar.month" | translate }}
                </div>
                <div
                  class="btn btn-primary"
                  (click)="setView(CalendarView.Week)"
                  [class.active]="view === CalendarView.Week"
                >
                  {{ "admin.campaigns.calendar.week" | translate }}
                </div>
                <div
                  class="btn btn-primary"
                  (click)="setView(CalendarView.Day)"
                  [class.active]="view === CalendarView.Day"
                >
                  {{ "admin.campaigns.calendar.day" | translate }}
                </div>
              </div>
            </div>
          </div>
          <br />
          <div [ngSwitch]="view" class="col-12">
            <mwl-calendar-month-view
              *ngSwitchCase="CalendarView.Month"
              [viewDate]="viewDate"
              [events]="events"
              [refresh]="refresh"
              [activeDayIsOpen]="activeDayIsOpen"
              (dayClicked)="dayClicked($event.day)"
              (eventClicked)="handleEvent('Clicked', $event.event)"
            >
            </mwl-calendar-month-view>
            <mwl-calendar-week-view
              *ngSwitchCase="CalendarView.Week"
              [viewDate]="viewDate"
              [events]="events"
              [refresh]="refresh"
              (eventClicked)="handleEvent('Clicked', $event.event)"
            >
            </mwl-calendar-week-view>
            <mwl-calendar-day-view
              *ngSwitchCase="CalendarView.Day"
              [viewDate]="viewDate"
              [events]="events"
              [refresh]="refresh"
              (eventClicked)="handleEvent('Clicked', $event.event)"
            >
            </mwl-calendar-day-view>
          </div>
        </div>
        <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
          {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
        </div>
        <div *ngIf="loading && !forbidden">
          <ng-container style="float: right" class="flex">
            <div class="loader-box">
              <div class="loader-34"></div>
            </div>
            <h6
              class="col align-self-center f-w-600"
              style="text-align: center"
            >
              {{ "fetching" | translate }}
            </h6>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #modalContent let-modal id="approveAdvertiserModal">
  <app-details-ad [detailsAd]="details"></app-details-ad>
</ng-template>
